import api from "@/core/services/api.service";

const acrService = {

    save(params) {
        api.setHeader()
        return api.post("api/acreditation/save", params)
    },

    delete(params) {
        api.setHeader()
        return api.post("api/acreditation/delete", params)
    },

    getList(params) {
        api.setHeader()
        return api.post("api/acreditation/list", params)
    },

    getMultimedia(params) {
        api.setHeader()
        return api.post("api/multimedia/list", params)
        
    }


    /*async configSport(params) {
        try {
            api.setHeader();
            const response = await  api.post(`api/${params.sport}/config`, params.data)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async delete(id) {
        try {
            api.setHeader();
            const response = await api.delete(`acr/delete/${id}`)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async edit(id) {
        try {
            api.setHeader();
            const response = await api.get("acr/edit", id)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async updateOfficer(params){
        try {
            api.setHeader();
            const response = await api.update("acr/officers/update", params.slug, params.data)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async status(params) {
        try {
            api.setHeader();
            const response = await api.post("acr/status", params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async typesFiles(params) {
        try {
            api.setHeader();
            const response = await api.post("acr/files/tipos", params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async filesUploads(id) {
        try {
            api.setHeader();
            const response = await api.get("acr/files", id)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async Teams(params){
        try {
            api.setHeader();
            const response = await api.post("acr/teams", params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async saveTeam(params){
        try {
            api.setHeader();
            const response = await api.post("acr/teams/save", params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },
    async editTeam(id){
        try {
            api.setHeader();
            const response = await api.get("acr/teams/edit", id)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async captain(params){
        try {
            api.setHeader();
            const response = await api.post("acr/teams/captain", params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    },

    async finish(params){
        try {
            api.setHeader();
            const response = await api.post("acr/finish", params)
            return response;
        } catch (error) {
            throw new acrError(error.response.status, error.response)
        }
    }
    */
}

export default acrService